module.exports = __webpack_public_path__ + "static/img/lb8.1b64484.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/lb8.png
// module id = VP+i
// module chunks = 0